import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed } from "shared/lib/styles";
export const Container = styled.div`
  margin-block-start: 24px;
`;
export const Label = styled.div`
  margin-block-end: 4px;

  color: rgb(255, 202, 5);
  font-weight: 700;
  font-size: 12px;
  line-height: 16.8px;
  text-transform: uppercase;
`;
export const Item = styled(BaseLink)`
  position: relative;

  display: flex;
  flex: 1 1 50%;
  gap: 12px;
  align-items: center;

  padding-block: 12px;
  border-block-end: 1px solid rgba(161, 161, 161, 0.3);
`;

type ChildrenProps = {
  $type: string;
};
export const Children = styled.div<ChildrenProps>`
  ${props =>
    props.$type === "topics"
      ? null
      : css`
          display: flex;
          flex-wrap: wrap;
          ${Item} {
            &:nth-child(2n -1) {
              padding-inline-end: 12px;
            }

            &:nth-child(2n) {
              padding-inline-start: 12px;
              &::after {
                position: absolute;
                inset-inline-start: 0;
                content: "";

                inline-size: 1px;
                block-size: 19.2px;

                background-color: rgba(161, 161, 161, 0.3);
              }
            }
          }
        `}
`;

export const ItemText = styled.span`
  flex: 1;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19.2px;
`;
